import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; 
import Header from '../navigation/headerContainer'; 
import Footer from '../navigation/footerContainer';

export default function PaymentCancelledPage() {
    const navigate = useNavigate();  

    useEffect(() => {
        // Redirect to homepage after 3 seconds
        const timer = setTimeout(() => {
            navigate('/'); 
        }, 3000);

        // Clean up the timeout on unmount
        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <>
            <Header />
            <main className="home accessDenied">
                <div className='background'>
                    <div className="mainName">
                        <span className="mainText">Payment Cancelled!</span>
                    </div>
                    <div className="nameSlogan">
                        <span className="slogan">Your payment was processed successfully. You will be redirected shortly....</span>
                    </div>
                </div>
            </main>
            <Footer />
    </>
    );
}

